function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 0C8.04256 0 0 8.16666 0 18.2778C0 32.4444 18 50 18 50C18 50 36 32.3888 36 18.2778C36 8.16666 27.9574 0 18 0ZM18 26.6666C13.459 26.6666 9.79332 22.9444 9.79332 18.3333C9.79332 13.7222 13.459 10 18 10C22.541 10 26.2066 13.7222 26.2066 18.3333C26.2066 22.9444 22.541 26.6666 18 26.6666Z",
  fill: "#4252A9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.414 48.8682C18.2517 49.036 18.1127 49.1781 17.9995 49.2929C17.8864 49.1785 17.7475 49.037 17.5856 48.87C17.0969 48.3659 16.3978 47.6291 15.5585 46.7003C13.8791 44.8422 11.6409 42.2187 9.40374 39.1564C4.9083 33.0029 0.5 25.1871 0.5 18.2778C0.5 8.43556 8.32589 0.5 18 0.5C27.6741 0.5 35.5 8.43556 35.5 18.2778C35.5 21.7051 34.4052 25.3767 32.734 28.9769C31.0647 32.5731 28.8343 36.0686 26.5961 39.1358C24.3589 42.2016 22.1205 44.8304 20.4412 46.6929C19.6017 47.6239 18.9026 48.3627 18.414 48.8682ZM9.29332 18.3333C9.29332 23.2133 13.1756 27.1666 18 27.1666C22.8243 27.1666 26.7066 23.2133 26.7066 18.3333C26.7066 13.4533 22.8243 9.5 18 9.5C13.1756 9.5 9.29332 13.4533 9.29332 18.3333Z",
  stroke: "black",
  strokeOpacity: 0.37
});

var SvgMarker = function SvgMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 50,
    viewBox: "0 0 36 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker.27626bb9.svg";
export { ForwardRef as ReactComponent };